import axios from 'axios'
import api from './index'
/**
 *
 * @type {{}}
 */
axios.defaults.timeout = 60000

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charest=utf-8'
// 添加请求拦截器
axios.interceptors.request.use(config => {
  return config
}, err => {
  return Promise.reject(err)
})
// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response
}, err => {
  return Promise.reject(err)
})
let base = '/mall'  // 线上
let basemarket = '/activity' // 线上
//let base = '/apis/mall' // 线下

// 开发环境接入地址：http://192.168.100.37:6060/play?uid=
// 测试环境接入地址：http://gamefacetest.maboy.cn/play?uid=
// 生产环境接入地址：https://gameface.maboy.cn/play?uid=
let acturl = "https://gameface.maboy.cn/play?uid=";

export default {
  GET_WXJSDKCINFIG: base + '/initJSSDK',
  // 获取分享链接
  GET_SHAREURL (params) {
    return api.fetch('post', `${base}/getShareUrl`, params)
  },
  // 保存分享记录
  GET_SAVESHARERECORD (params) {
    return api.fetch('post', `${base}/saveShareRecord`, params)
  },
  //  根据域名初始访问的企业
  GET_CMPYINFOBYREQDOMAIN (params) {
    return api.fetch('post', `${base}/initModel`, params)
  },
  // 获取企业模板
  INITMODEL (params) {
    return api.fetch('post', `${base}/initModel`, params)
  }
}



// WEBPACK FOOTER //
// ./src/apis/api.js